export default __webpack_public_path__ + "static/1-75b655d284de9fe9bd800447eb8e040f.png";